var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorscsat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 36,
    viewBox: "0 0 22 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49618 0.208496C5.60873 0.208496 3.79858 0.958285 2.46394 2.29292C1.12931 3.62755 0.379517 5.43771 0.379517 7.32516V14.4418C0.379517 16.3293 1.12931 18.1394 2.46394 19.4741C3.79858 20.8087 5.60873 21.5585 7.49618 21.5585H14.6129V28.6752H0.379517V35.7918H14.6129C16.5003 35.7918 18.3105 35.042 19.6451 33.7074C20.9797 32.3728 21.7295 30.5626 21.7295 28.6752V21.5585C21.7295 19.671 20.9797 17.8609 19.6451 16.5263C18.3105 15.1916 16.5003 14.4418 14.6129 14.4418H7.49618V7.32516H21.7295V0.208496H7.49618Z",
    fill: "#33697A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorscsat);
export default __webpack_public_path__ + "static/media/Vectorscsat.841d8a1cb0c7b7c6a7bd898f5abe35a0.svg";
export { ForwardRef as ReactComponent };